import { BonusModal } from "@desktop/components/Modal/BonusModal";
import {
  hideBonusModal,
  showBonusModal,
  takeBonus,
} from "@shared/actions/bonuses";
import { signIn, signOut, updateBalance } from "@shared/actions/user";
import { WarningModal } from "@shared/components/Common/warning-modal";
import ScrollContent from "@shared/containers/ScrollContent";
import { useBonuses } from "@shared/hooks/bonuses";
import { useUserState } from "@shared/hooks/user";
import { hasUser } from "@shared/utils/users";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

import Footer from "../../components/Footer/Footer";
import StickyFooter from "../../components/Footer/StickyFooter";
import { Header } from "../../components/Header";
import Modal from "../../components/Modal/LoginModal";

import { HomeLayout } from "./HomeLayout";

import type { LocationState } from "history";

const theme = process.env.REACT_APP_THEME;
const isPlayYVegasTheme = theme === "playyvegas";

export const HomePage = () => {
  const dispatch = useDispatch();
  const bonusesState = useBonuses();
  const userState = useUserState();
  const isAuth = hasUser(userState);
  const [isModalShown, setIsModalShown] = useState(false);
  const { location } = useHistory();
  const locationState = location?.state satisfies LocationState;
  const isShowAuthModalFromLocation = (
    locationState as { showAuthModal: boolean }
  )?.showAuthModal;
  const onAuthEnter = (login: string, password: string) => {
    dispatch(signIn(login, password));
  };

  const onAuthExit = () => dispatch(signOut());
  const closeModal = () => setIsModalShown(false);
  const refreshBalance = () => dispatch(updateBalance());

  useEffect(() => {
    if (locationState && isShowAuthModalFromLocation) {
      setIsModalShown(true);
      location.state = {};
    } else {
      setIsModalShown(false);
    }
  }, [location]);

  return (
    <div className="layout">
      <Header
        authData={userState}
        updateBalance={refreshBalance}
        onAuthEnter={onAuthEnter}
        onAuthExit={onAuthExit}
        bonus={bonusesState.bonus}
        showBonusModal={() => dispatch(showBonusModal())}
      />

      <ScrollContent>
        <HomeLayout />
        <Footer />
      </ScrollContent>

      {!isAuth && (
        <Modal
          onAuth={onAuthEnter}
          close={closeModal}
          showModal={isModalShown}
          loading={userState?.loading}
          error={userState.error}
        />
      )}
      {bonusesState.isModalShown &&
        bonusesState.bonus !== null &&
        bonusesState.bonus.available && (
          <BonusModal
            takeBonus={() => dispatch(takeBonus())}
            hideBonusModal={() => dispatch(hideBonusModal())}
          />
        )}
      <WarningModal />
      {/* todo Избавиться от логики темы*/}
      {isPlayYVegasTheme && <StickyFooter />}
    </div>
  );
};

HomePage.displayName = "HomePage";
